import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Wrapper } from './style';

const Toast = () => (
  <Wrapper>
    <ToastContainer
      limit={1}
      toastClassName="JNM-Toast"
    />
  </Wrapper>
);

export default Toast;
